import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=7d672491&lang=pug&"
import script from "./HeaderMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d672491')) {
      api.createRecord('7d672491', component.options)
    } else {
      api.reload('7d672491', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=7d672491&lang=pug&", function () {
      api.rerender('7d672491', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/HeaderMenu.vue"
export default component.exports